import dynamic from "next/dynamic";

const AdminHeader = dynamic(() => import("./AdminHeader"), {
  ssr: false,
});

export default AdminHeader;
